import { Editor, Plugin } from "ckeditor5";

import { collectModelElements } from "../util/document";

export type ItemEditorGap = {
  id: string;
  label: string;
  suggestedText?: string;
};

export type ItemEditorHotText = {
  id: string;
  body: string;
};

export class ItemEditorApi {
  private editor: Editor;

  constructor(editor: Editor) {
    this.editor = editor;
  }

  get gaps(): ItemEditorGap[] {
    const gapElements = collectModelElements(
      this.editor.model.document.getRoot(),
      "gap",
    );

    return gapElements.map((e, i) => ({
      label: `Gap ${i + 1}`,
      id: e.getAttribute("id") as string,
      suggestedText: e.getAttribute("suggestedText") as string | undefined,
    }));
  }

  get hottexts(): ItemEditorHotText[] {
    const hottextElements = collectModelElements(
      this.editor.model.document.getRoot(),
      "hottext",
    );

    return hottextElements.map((e) => ({
      id: e.getAttribute("id") as string,
      body: this.editor.data.stringify(e),
    }));
  }
}

export default class ItemEditor extends Plugin {
  init() {
    Object.defineProperty(this.editor, "item", {
      value: new ItemEditorApi(this.editor),
      writable: false,
    });
  }
}

declare module "ckeditor5" {
  interface Editor {
    item?: ItemEditorApi;
  }
}
